import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  /**
   * Go to anchor
   * @param {string} value
   */
  public goToCycle = (value: string) => {
    const url = this.router.url;
    if (url === '/' || url === '/#full-cycle') {
      try {
        document.querySelector('#' + value).scrollIntoView();
        // now account for fixed header
        const scrolledY = window.scrollY;
        const yourHeight = 93;
        if (scrolledY) {
          window.scroll(0, (scrolledY - yourHeight) - 250);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      this.router.navigate(['/'], {fragment: value});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.component.ts